import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductDetailsMainSlider, ProductDetailsThumbSlider } from '../../shared/data/slider';
import { AuthService } from '../../shared/services/auth.service';
import { RestaurantService } from '../../shared/services/restaurant.service';
import { CartService } from '../../shared/services/cart-service';
import { CustomModalComponent } from '../../shared/components/modal/custom-modal/custom-modal.component';
//import { SizeModalComponent } from "../../../shared/components/modal/size-modal/size-modal.component";
import { TypePayment, DB, RESPONSE, AppInfo } from '../../shared/services/env.service';
import { TypeOrder, ET_RestaurantServiceTypeEnabled } from '../../shared/services/config-app';
import { EitCart } from '../../shared/classes/eitcart';
import { EitPlace } from '../../shared/classes/eitplace';
import { ReviewBoxComponent } from '../../shared/components/restaurant/review-box/review-box.component';
import { InfoPromoBoxComponent } from '../../shared/components/restaurant/info-promo-box/info-promo-box.component';
import { InfoBoxComponent } from '../../shared/components/restaurant/info-box/info-box.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationSelectComponent } from '../../shared/components/modal/location-select/location-select.component';
import { AllergensComponent } from '../../shared/components/modal/allergens/allergens.component';
import { AppService } from '../../shared/services/app.service';

@Component({
  selector: 'app-rest-takeaway',
  templateUrl: './rest-takeaway.component.html',
  styleUrls: ['./rest-takeaway.component.scss']
})
export class RestTakeawayComponent implements OnInit {

  public record: any = {};
  public restaurant: any = {};
  public restFull: any = {};
  public location: any = {};
  public counter: number = 1;
  public activeSlide: any = 0;
  public selectedSize: any;
  public gallery = [];
  public promozioni = []
  list: any;
  public themeLogo: string = ''; // Change Logo
  //cartData: any = "";
  typeOrder: any = "";
  service: any = "1";
  typeService: any = "";
  public isCollapsedMenu = false;
  public isCollapsedReview = true;
  public isCollapsedPromo = true;
  public isCollapsedInfo = true;
  sticky: boolean = true;
  public stick: boolean = false;

  @ViewChild("customModal") CustomModal: CustomModalComponent;
  @ViewChild("collapseReview") collapseReview: ReviewBoxComponent;
  @ViewChild("collapsePromo") collapsePromo: InfoPromoBoxComponent;
  @ViewChild("collapseInfo") collapseInfo: InfoBoxComponent;
  //@ViewChild("sizeChart") SizeChart: SizeModalComponent;

  public ProductDetailsMainSliderConfig: any = ProductDetailsMainSlider;
  public ProductDetailsThumbConfig: any = ProductDetailsThumbSlider;

  constructor(private route: ActivatedRoute, private appService: AppService,
    public auth: AuthService, public restService: RestaurantService,
    private modalService: NgbModal, public cartService: CartService) {
    this.route.data.subscribe(response => this.record = response.data);

    this.typeOrder = TypeOrder;
    this.typeService = ET_RestaurantServiceTypeEnabled;
    //this.cartData = new EitCart();
    this.location = new EitPlace();
    this.restFull = null;
    
    this.appService.appObs.subscribe(x => {  
      this.themeLogo = this.appService.getLogo(x);
    });

    console.log("rt")

    this.restaurant = JSON.parse(localStorage.getItem(DB.ACTIVITY_BASE));
    var loc = JSON.parse(localStorage.getItem(DB.LOCATION));

    if (loc) {
      this.location = loc;
    } else {
      //popup
    }

    if (this.restaurant && this.restaurant.media_header) {
      this.gallery.push(AppInfo.ASSETS_URL + this.restaurant.media_header.filename);
    }

    this.restService.restaurant.subscribe(x => {
      if (x) {
        this.restFull = x;
        this.promozioni = [];
        if (this.restFull && this.restFull.promozioni) {
          for (var p = 0; p < this.restFull.promozioni.length; p++) {
            if (this.restFull.promozioni[p].status == 1 && this.restFull.promozioni[p].validity_type != 1){
              this.promozioni.push(this.restFull.promozioni[p]);
            }
          }
        }
        if (this.restFull && this.restFull.media_header && (!this.restaurant || !this.restaurant.media_header)) {
          this.gallery.push(AppInfo.ASSETS_URL + this.restFull.media_header.filename);
        }
    
      }
    });

    if(this.restaurant){
      var ispreorder = (!this.restaurant.message_event && this.restaurant.nowclosed && !this.restaurant.day_closed && this.restaurant.preorder);
      this.cartService.createCart(this.restaurant.id, this.auth.idOrder, this.location, this.typeOrder.EIT_ASPORTO, ispreorder)
    }

    this.restService.list.subscribe(x => {

      this.list = x;

    });



    /* this.cartService.cartObs.subscribe(x => {
 
       this.cartData = x;
 
     });*/
  }

  ngOnInit(): void {
  }

  // @HostListener Decorator
  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number >= 300 && window.innerWidth > 400) {
      this.stick = true;
    } else {
      this.stick = false;
    }
  }

  selectPage(indexPage) {
    switch (indexPage) {
      case 0:
        {
          this.isCollapsedMenu = false;
          this.isCollapsedPromo = true;
          this.isCollapsedReview = true;
          this.isCollapsedInfo = true;
          this.collapseReview.canScroll = false;
          this.collapsePromo.canScroll = false;
        }
        break;

      case 1:
        {
          this.isCollapsedMenu = true;
          this.isCollapsedPromo = true;
          this.isCollapsedReview = false;
          this.isCollapsedInfo = true;
          this.collapseReview.init()
          this.collapseReview.canScroll = true;
          this.collapsePromo.canScroll = false;
        }
        break;

      case 2:
        {
          this.isCollapsedMenu = true;
          this.isCollapsedPromo = true;
          this.isCollapsedReview = true;
          this.isCollapsedInfo = false;
          this.collapseInfo.init()
          this.collapseReview.canScroll = false;
          this.collapsePromo.canScroll = false;
        }
        break;

      case 3:
        {
          this.isCollapsedMenu = true;
          this.isCollapsedPromo = false;
          this.isCollapsedReview = true;
          this.isCollapsedInfo = true;
          this.collapsePromo.init()
          this.collapseReview.canScroll = false;
          this.collapsePromo.canScroll = true;
        }
        break;
    }

  }

  ingredients(item) {
    var result = "";

    for (var iG = 0; iG < item.ingredients.length; iG++) {
      result += item.ingredients[iG].name;
      if (iG < item.ingredients.length - 1) {
        result += ", ";
      }
    }

    return result;
  };

  shortDescr(item) {
    var result = "";

    if (item.descr.length > 0 && item.descr.length < 15) {
      result = " (" + item.descr + ")";
    }

    return result;
  }

  longDescr(item) {
    var result = "";

    if (item.descr.length > 15) {
      result = item.descr + " ";
    }

    return result;
  }

  editLocation() {
    let modal = this.modalService.open(LocationSelectComponent,  { size: 'lg', centered: true, ariaLabelledBy: 'Location-Modal',  backdrop: 'static'})
    modal.componentInstance.onDismiss.subscribe((event: any) => {
      if(event.status == RESPONSE.JPS_OK){
        //this.fillFidelity()
        let loc = JSON.parse(localStorage.getItem(DB.LOCATION));
        if (loc) {
          this.location = loc;
        } 
      }
    })
  }

  openAllegerni() {
    let modal = this.modalService.open(AllergensComponent,  { size: 'md', centered: true, ariaLabelledBy: 'Allergens-Modal',  backdrop: 'static'})
    modal.componentInstance.allergens = this.restFull.allergens
    modal.componentInstance.link_allergens = this.restFull.menu.link_allergens
  }
}
